import { useEffect, useRef, useState } from "react";

import { Alert, Snackbar } from "@mui/material";
import ConfirmAddPersonnel from "../../../ui/ConfirmAddPersonnel";
import SocieteAndUserService from "../../../services/societeAndUser";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { PermCameraMic } from "@material-ui/icons";
import getCurrentUserId from "../../../reduxSaga/sagas/requests/currentUserId";
import UploadAndDownloadService from "../../../services/uploadAndDownloadFile";
import { useNavigate } from "react-router-dom";
import SocieteService from "../../../services/SocieteService";
import ContactTable from "./ContactTable";
const styles = {
  container: (base) => ({
    ...base,
    flex: 1,
    zIndex: 9999,
  }),
};
const AddContactSociete = () => {
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();
  const [personalName, setPersonalName] = useState("");
  const navigate = useNavigate();
  const [openSuccessAlert, setOpenSuccessAlert] = useState(false);
  const [successAlertText, setSuccessAlertText] = useState();
  const [isCancel, setIsCancel] = useState(false);
  // const [personalSociete, setPersonalSociete] = useState("");
  // const [showLocalisationAndTruck, setShowLocalisationAndTruck] =
  //   useState(true);
  // const [selectedOption, setSelectedOption] = useState([]);
  // const [allRoles, setAllRoles] = useState([]);
  const [personalPrenom, setPersonalPrenom] = useState("");
  const [personalCIN, setPersonalCIN] = useState("");
  // const [personalLocalisation, setPersonalLocalisation] = useState("");
  // const [personalCamion, setPersonalCamion] = useState("");
  // const [personalPassword, setPersonalPassword] = useState("");
  // const [personalRePassword, setPersonalRePassword] = useState("");
  const [personalEmail, setPersonalEmail] = useState("");
  const [personalFonction, setPersonalFonction] = useState("");

  const [personalPhoneNumber, setPersonalPhoneNumber] = useState("");
  // const displayLocalisation = useRef(null);
  // const displayCamion = useRef(null);
  const [openInfoAlert, setOpenInfoAlert] = useState(false);
  const [infoAlertText, setInfoAlertText] = useState();
  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState("Choisir une image");
  const [fileDataURL, setFileDataURL] = useState(null);
  const [openAlert, setOpenAlert] = useState(false);
  const [listContacts, setListContacts] = useState([]);

  useEffect(() => {
    SocieteService.getSocietesContacts(
      getCurrentUserId(),
      sessionStorage.getItem("SocieteContactId")
    )
      .then((response) => {
        if (response.data.success) {
          setListContacts(response.data.success);
        }
      })
      .catch((e) => {
        console.log("error", e);
      });
  }, []);
  const handleSuccessClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSuccessAlert(false);
  };

  useEffect(() => {
    let fileReader,
      isCancel = false;
    if (file) {
      fileReader = new FileReader();
      fileReader.onload = (e) => {
        const { result } = e.target;
        if (result && !isCancel) {
          setFileDataURL(result);
        }
      };
      fileReader.readAsDataURL(file);
    }
    return () => {
      isCancel = true;
      if (fileReader && fileReader.readyState === 1) {
        fileReader.abort();
      }
    };
  }, [file]);

  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };

  const onChangepersonalName = (event) => {
    setPersonalName(event.target.value);
  };

  const onChangePersonalPrenom = (event) => {
    setPersonalPrenom(event.target.value);
  };

  const onChangePersonalCin = (event) => {
    setPersonalCIN(event.target.value);
  };

  const onChangePersonalEmail = (event) => {
    setPersonalEmail(event.target.value);
  };
  const onChangePersonalFonction = (event) => {
    setPersonalFonction(event.target.value);
  };
  const onChangePersonalPhoneNumber = (event) => {
    setPersonalPhoneNumber(event.target.value);
  };

  const onUploadImageHandler = (e) => {
    if (e.target.files[0].size > 2097152) {
      setOpenInfoAlert(true);
      setInfoAlertText("la taille du fichier ne doit pas dépasser 2 Mo");
    } else {
      const file = e.target.files[0];

      setFile(file);
      setFileName(e.target.files[0].name);
    }
  };

  const handleInfoClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenInfoAlert(false);
  };
  const onConfirmedAddPersonnelHandler = () => {
    if (personalName === "") {
      setErrorAlertText("Erreur :le champ nom  est vide ! ");
      setOpenErrorAlert(true);
    } else if (personalPrenom === "") {
      setErrorAlertText("Erreur :le champ prénom  est vide ! ");
      setOpenErrorAlert(true);
    } else if (personalCIN === "") {
      setErrorAlertText("Erreur :le champ CIN  est vide ! ");
      setOpenErrorAlert(true);
    } else if (personalEmail === "") {
      setErrorAlertText("Erreur :le champ email est vide ! ");
      setOpenErrorAlert(true);
    } else if (personalPhoneNumber === "") {
      setErrorAlertText("Erreur :le champ télephone est vide ! ");
      setOpenErrorAlert(true);
    } else {
      let confirmModel = {
        lastName: personalName,
        firstName: personalPrenom,
        cin: personalCIN,
        email: personalEmail,
        fonction: personalFonction,
        phoneNumber: personalPhoneNumber,
        idSocieteContact: sessionStorage.getItem("SocieteContactId"),
        idUser: getCurrentUserId(),
      };
      if (file != null) {
        const uploadData = new FormData();
        uploadData.append("picture", file);
        let emailExist = false;

        UploadAndDownloadService.uploadFile(
          "/retail/uploadFile/uploadFile/UserPicture",
          uploadData
        )
          .then((response) => {
            if (Object.keys(response.data)[0] === "success") {
              confirmModel.urlFile = response.data.success;

              SocieteService.addContact(confirmModel)
                .then((response) => {
                  if (Object.keys(response.data)[0] === "success") {
                    setOpenSuccessAlert(true);
                    setSuccessAlertText("Enregistrement avec succées");
                    setTimeout(() => {
                      navigate(`/tiers`);
                    }, 2000);
                  } else if (Object.keys(response.data)[0] === "errorExist") {
                    setOpenInfoAlert(true);
                    setInfoAlertText("Info :Email déja exist");

                    emailExist = true;
                  }
                })
                .catch(() => {
                  setOpenErrorAlert(true);
                  setErrorAlertText("Erreur : il ya un probléme de connection");
                });
            } else {
              setOpenErrorAlert(true);
              setErrorAlertText("Erreur : il ya un erreur  ");
            }
          })
          .catch(() => {
            setOpenErrorAlert(true);
            setErrorAlertText("Erreur : il ya un probléme de connection");
          });
      } else {
        let emailExist = false;

        SocieteService.addContact(confirmModel)
          .then((response) => {
            if (Object.keys(response.data)[0] === "success") {
              setOpenSuccessAlert(true);
              setSuccessAlertText("Enregistrement avec succées");
              setTimeout(() => {
                navigate(`/tiers`);
              }, 2000);
            } else if (Object.keys(response.data)[0] === "errorExist") {
              setOpenInfoAlert(true);
              setInfoAlertText("Info :Email déja exist");

              emailExist = true;
            }
          })
          .catch(() => {
            setOpenErrorAlert(true);
            setErrorAlertText("Erreur : il ya un probléme de connection");
          });
      }
      console.log(confirmModel);
    }
  };

  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <section className="content-header">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-6"></div>
            <div className="col-md-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item">Home</li>
                <li class="breadcrumb-item active">Les contacts</li>
              </ol>
            </div>
          </div>
        </div>
      </section>

      {listContacts.length !== 0 && (
        <section className="content ">
          <div className="container-fluid">
             
                <ContactTable listClients={listContacts} />
                </div>
           
        </section>
      )}
      <section className="content ">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="card card-dark">
                <div className="card-header">
                  <h5 className="card-title"> Les contacts</h5>
                </div>

                <div class="card-body">
                  <div class="row">
                    <div className="col-sm-4">
                      <div className="form-group">
                        <label htmlFor="inputName">Nom</label>
                        <input
                          placeholder="Ajouter Nom "
                          onChange={onChangepersonalName}
                          type="text"
                          id="inputName"
                          className="form-control"
                        />
                      </div>
                    </div>
                    <div className="col-sm-4">
                      <div className="form-group">
                        <label htmlFor="inputName">Prénom</label>
                        <input
                          placeholder="Ajouter prénom "
                          onChange={onChangePersonalPrenom}
                          type="text"
                          id="inputName"
                          className="form-control"
                        />
                      </div>
                    </div>

                    <div className="col-sm-4">
                      <div className="form-group">
                        <label htmlFor="inputName">Fonction</label>
                        <input
                          placeholder="Ajouter fonction "
                          onChange={onChangePersonalFonction}
                          type="text"
                          id="inputName"
                          className="form-control"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div className="col-sm-4">
                      <div className="form-group">
                        <label htmlFor="inputName">CIN</label>
                        <input
                          placeholder="Ajouter CIN "
                          onChange={onChangePersonalCin}
                          type="text"
                          id="inputName"
                          className="form-control"
                        />
                      </div>
                    </div>
                    <div className="col-sm-4">
                      <div className="form-group">
                        <label htmlFor="inputName">Email</label>
                        <input
                          placeholder="Ajouter email "
                          onChange={onChangePersonalEmail}
                          type="email"
                          id="inputName"
                          className="form-control"
                        />
                      </div>
                    </div>
                    <div className="col-sm-4">
                      <div className="form-group">
                        <label htmlFor="inputName">Télephone</label>
                        <input
                          placeholder="Ajouter Télephone"
                          onChange={onChangePersonalPhoneNumber}
                          type="text"
                          id="inputName"
                          className="form-control"
                        />
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div className="form-group" class="col-sm-6">
                      <div
                        class="input-group mb-3 px-2 py-2   sm-white border"
                        style={{ marginTop: 100 }}
                      >
                        <input
                          id="upload"
                          type="file"
                          accept=".jpg, .jpeg, .png"
                          className="form-control border-0"
                          onChange={onUploadImageHandler}
                        />

                        <label
                          id="upload-label"
                          for="upload"
                          class="font-weight-light text-muted"
                        >
                          {fileName}
                        </label>
                        <div class="input-group-append">
                          <label
                            for="upload"
                            class="btn btn-light m-0 rounded-pill px-4"
                          >
                            {" "}
                            <i class="fa fa-cloud-upload mr-2 text-muted"></i>
                            <small class="text-uppercase font-weight-bold text-muted">
                              Choisir une image
                            </small>
                          </label>
                        </div>
                      </div>
                    </div>

                    <div className="form-group" class="col-sm-6">
                      <div
                        class="image-area mt-4"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          verticalAlign: "middle",
                        }}
                      >
                        {fileDataURL ? (
                          <img
                            id="imageResult"
                            src={fileDataURL}
                            alt
                            style={{ height: 197, width: 620 }}
                            className="img-fluid rounded shadow-sm mx-auto d-block"
                          />
                        ) : (
                          <img
                            style={{ marginTop: 180 }}
                            id="imageResult"
                            src="#"
                            alt
                            className="img-fluid rounded shadow-sm mx-auto d-block"
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card-footer">
                  <button
                    class="btn btn-dark float-right"
                    onClick={onConfirmedAddPersonnelHandler}
                  >
                    Confirmer
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Snackbar
        open={openErrorAlert}
        autoHideDuration={2000}
        onClose={handleEroorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleEroorClose} severity="error">
          {errorAlertText}
        </Alert>
      </Snackbar>
      <Snackbar
        open={openSuccessAlert}
        autoHideDuration={2000}
        onClose={handleSuccessClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleSuccessClose} severity="success">
          {successAlertText}
        </Alert>
      </Snackbar>
      <Snackbar
        open={openInfoAlert}
        autoHideDuration={4000}
        onClose={handleInfoClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert onClose={handleInfoClose} severity="error">
          {infoAlertText}
        </Alert>
      </Snackbar>
      <Snackbar
        open={openErrorAlert}
        autoHideDuration={1000}
        onClose={handleEroorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert onClose={handleEroorClose} severity="success">
          Ajout avec success !
        </Alert>
      </Snackbar>

      {/* {onConfirmAddPersonnel && (
        <ConfirmAddPersonnel
          setOnConfirmAddPersonnel={setOnConfirmAddPersonnel}
          confirmPersonnelModel={confirmPersonnelModel}
          setIsCancel={setIsCancel}
        />
      )} */}
    </div>
  );
};
export default AddContactSociete;
